import { useAtom, useSetAtom } from "jotai";
import { authAtom, nameResultsAtom, userAtom } from "../store/store";
import ToastService from "../components/common/Toast/ToastService";

export function useUser() {
  const [auth, setAuth] = useAtom(authAtom);
  const setNameResult = useSetAtom(nameResultsAtom);
  const setUser = useSetAtom(userAtom);

  const openLoginModal = () => {
    setAuth({ modalVisible: true, mode: "login" });
  };

  const openRegisterModal = () => {
    setAuth({ modalVisible: true, mode: "register" });
  };

  const closeAuthModal = () => {
    setAuth((pre) => ({ ...pre, modalVisible: false }));
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser({
      isLogin: false,
      email: "",
      nickname: "",
    });
    setNameResult([]);
    ToastService.success("You have been logged out.");
  };

  return {
    auth,
    openLoginModal,
    openRegisterModal,
    closeAuthModal,
    logout,
  };
}
